import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as profileActions from '../../actions';
import Ionicon from 'react-ionicons';
import { currency } from '../../../../../../helpers/';
import { siteOfOriginHelper } from '../../../../../../helpers/genericHelpers';

class Investments extends Component {
	constructor() {
		super();
		this.state = {
			investor: false,
			range: '',
			editing: false,
			investmentId: '',
			createInvestment: false,
		};
	}

	componentDidMount() {
		this.setState({
			investor: !this.props.noData,
			range: this.props.range,
			investmentId: this.props.investment_id,
			createInvestment: this.props.noData,
		});
	}

	handleSubmit = () => {
		this.props.dispatch(
			profileActions.changeInvestments(
				this.props.personId,
				{ investment_id: this.state.investmentId },
				this.state.createInvestment
			)
		);
		return this.setState({ editing: false });
	};

	setCurrencySymbol(ranges) {
		if (!Array.isArray(ranges)) {
			return ranges;
		}
		return siteOfOriginHelper() === 'us'
			? ranges.map(item => ({
					range: item.range.replace(/[£]/g, '$'),
					id: item.id,
			  }))
			: ranges;
	}

	render() {
		if (this.props.guestMode) return null;
		const ranges = this.setCurrencySymbol(this.props.ranges);
		const range =
			Array.isArray(ranges) &&
			ranges
				.map(item => ({ value: item.id, label: item.range }))
				.find(item => item.value === this.state.investmentId);

		return (
			<section
				id="investments"
				className="user-summary"
				style={{ marginBottom: '0' }}
			>
				<div className="container">
					<div className="row">
						<div className="col-12 profile-list">
							<div className="profile-section-header-box">
								<h2 className="h2 profile-section-header">Investments</h2>
								<button
									type="button"
									data-position="right"
									className={`btn btn-circle btn-add header-btn`}
									onClick={() =>
										this.setState({ editing: !this.state.editing })
									}
								>
									<span className="icon">
										<Ionicon
											icon={
												this.state.editing ? 'ion-android-close' : 'ion-edit'
											}
										/>
									</span>
								</button>
								<div className="row">
									<div className="profile-summary-body">
										<p className="p-tag section-visibility-info ">
											Investments are not made public when you publish your
											profile.
										</p>
										<div className="col-12 col-sm-8">
											<h3 className="h3">
												Are you looking to invest in a business?
											</h3>
										</div>
										<div className="col-12 col-sm-4">
											{!this.state.editing && (
												<h3 className="h3">
													{this.state.investor ? 'Yes' : 'No'}
												</h3>
											)}
											{this.state.editing && (
												<ul className="buttons-left">
													<li>
														<button
															className="btn btn-primary--ghost"
															onClick={() =>
																this.setState({
																	investor: false,
																	investmentId: '',
																	range: '',
																})
															}
														>
															<span className="label">No</span>
														</button>
													</li>
													<li>
														<button
															className="btn btn-primary"
															onClick={() => this.setState({ investor: true })}
														>
															<span className="label">Yes</span>
														</button>
													</li>
												</ul>
											)}
										</div>
										{this.state.investor && (
											<div>
												<div className="col-12 col-sm-8">
													<h3 className="h3 investment-label">
														How much money do you have available?
													</h3>
												</div>
												<div
													className="col-12 col-sm-4"
													className="investment-price"
												>
													{!this.state.editing && (
														<h4 className="h4">{range.label}</h4>
													)}
													{this.state.editing && (
														<div
															className="form-standard-profile"
															style={{
																padding: '0',
																background: 'transparent',
																margin: '0',
															}}
														>
															<Select
																value={range}
																placeholder={'Select...'}
																options={ranges.map(option => {
																	return {
																		value: option.id,
																		label: option.range,
																	};
																})}
																onChange={obj =>
																	this.setState({
																		investmentId: obj.value,
																		range: obj.label,
																	})
																}
															/>
														</div>
													)}
												</div>
											</div>
										)}
									</div>
								</div>
								{this.state.editing && (
									<button
										className="btn btn-primary"
										disabled={this.state.investor && !this.state.investmentId}
										onClick={() => this.handleSubmit()}
									>
										<span className="label">Submit</span>
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default connect()(Investments);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/Investments.js